export default '"Helvetica Neue", Arial, Helvetica, sans-serif';



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/data/font-family.js